import { get } from "lodash";
import React from "react";

import {
  convertToRem,
  convertFromRem,
} from "@/Apps/Pages/MobileResponsiveToggle/style";
import { MobileState } from "@/Apps/Pages/MobileResponsiveToggle/types";

import { ButtonSliderGroup, W } from "../BuildingBlocks/ButtonSliderGroup/ButtonSliderGroup";

import { PaddingProps } from "./types";

import { Minus, Plus } from "@phosphor-icons/react";
/**
 * Creates a Button Slider Group to Change the Components Padding
 */

const Padding: React.FC<PaddingProps> = ({
  onChange = () => null,
  settings = {},
  updateComponentStyle = () => null,
  minValue = 0,
  maxValue = 200,
  getMobileState = () => ({
    type: MobileState.FULLSCREEN,
  }),
  useRem = true,
}) => {
  const padding = get(settings, "properties.padding", 0);

  // send raw pixel value to the button slider even if input value is in rem
  const convertedValue = Number(
    convertFromRem(padding, getMobileState()["type"])
  );

  const handleChange = (value, shouldDbUpdate = true, wait = 100) => {
    const paddingOffset =
      value === "SHRINK" ? convertedValue - 5 : convertedValue + 5;
    const newPadding = Number.isInteger(value) ? value : paddingOffset;

    // convert the raw pixel value to rem before saving it the db
    const newValue = useRem
      ? convertToRem(newPadding, getMobileState()["type"])
      : newPadding;

    const newStyle = {
      padding: newValue,
    };

    updateComponentStyle(settings.id, newStyle, shouldDbUpdate, wait);

    onChange();
  };

  return (
    <div data-testid="Properties-Padding">
      <ButtonSliderGroup
        onChange={handleChange}
        text="Padding"
        button1={{ icon: <Minus />, value: "SHRINK" }}
        button2={{ icon: <Plus />, value: "GROW" }}
        minValue={minValue}
        maxValue={maxValue}
        value={convertedValue}
      />
    </div>
  );
};

export default Padding;
